import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';

import { ApplicationModulesIds } from '../../app/module-registry/application-modules';
import { AppointmentDetailAliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.APPOINTMENT_DETAIL })
export default class AppointmentsDetailController extends BaseController {

  @OnMount({ target: AppointmentDetailAliases.LAYOUT_DETAILS })
  onMounte(): void {
    const event = new CustomEvent('updateModulesRoute', { detail: { moduleId: ApplicationModulesIds.APPOINTMENTS } });
    dispatchEvent(event);
  }

}
